import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Banner from 'components/Banner';
import Typography from 'components/Typography';

import { IntlMsgShape } from 'helpers/consts';

import { withTabBar } from 'store/modules/appSettings';
import { hideBanner, bannerMessage, bannerVisible } from 'store/modules/banner';

const BannerContainer = () => {
  const dispatch = useDispatch();

  const withTabBarState: boolean | undefined = useSelector(withTabBar);

  const isBannerVisible: boolean | undefined = useSelector(bannerVisible);

  const text: IntlMsgShape = useSelector(bannerMessage);

  return (
    <Banner
      withTabBar={withTabBarState}
      onClose={() => {
        dispatch(hideBanner());
      }}
      showBanner={isBannerVisible}
    >
      <Typography variant="h3" component="span">
        {text && text.id !== '' && <FormattedMessage {...text} />}
      </Typography>
    </Banner>
  );
};

export default BannerContainer;
